import { useRef, useState } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { Download, Printer, ExternalLink } from "lucide-react";
import { Input } from "@/components/ui/input";
import { PageHeader, Panel, DarkBtn, Field } from "@/components/admin/AdminUI";

const download = (canvasId, name) => {
  const canvas = document.getElementById(canvasId);
  const a = document.createElement("a");
  a.href = canvas.toDataURL("image/png");
  a.download = `${name}.png`;
  a.click();
};

const QrCard = ({ url, label, id, size = 180 }) => (
  <div className="rounded-lg border-2 border-[#D4AF37] bg-[#140D0B] text-[#FDFBF7] p-5 flex flex-col items-center text-center break-inside-avoid" data-testid={`qr-card-${id}`}>
    <p className="font-display text-sm tracking-[0.2em]">YENİ MERCAN</p>
    <p className="text-[9px] tracking-[0.4em] text-[#D4AF37] mb-3">RESTORAN</p>
    <div className="bg-white p-3 rounded-md">
      <QRCodeCanvas id={id} value={url} size={size} level="H" includeMargin={false} fgColor="#140D0B" imageSettings={{ src: "/brand/logo.png", height: size * 0.22, width: size * 0.22, excavate: true }} />
    </div>
    <p className="mt-3 font-serif-ym text-xl">{label}</p>
    <p className="text-[10px] text-[#CBBBAE]">Menüyü görmek için okutun</p>
    <button onClick={() => download(id, label.replace(/\s/g, "-"))} className="no-print mt-3 inline-flex items-center gap-1 text-xs text-[#D4AF37]" data-testid={`qr-download-${id}`}><Download size={12} /> PNG indir</button>
  </div>
);

export default function QRMenu() {
  const [base, setBase] = useState(`${window.location.origin}/qr/mercan`);
  const [count, setCount] = useState(10);
  const [start, setStart] = useState(1);
  const ref = useRef();
  const tables = Array.from({ length: Math.min(Math.max(Number(count) || 0, 0), 100) }, (_, i) => Number(start) + i);

  return (
    <div data-testid="admin-qr-page">
      <div className="no-print">
        <PageHeader title="QR Menü" desc="Masalara koymak için QR kodlar oluşturun. Masa QR'ı okutulduğunda müşteri garson çağırabilir ve hesap isteyebilir.">
          <DarkBtn onClick={() => window.print()} data-testid="admin-qr-print-btn"><Printer size={16} /> Tümünü Yazdır</DarkBtn>
        </PageHeader>
        <Panel className="p-5 mb-6 grid sm:grid-cols-4 gap-4 items-end">
          <div className="sm:col-span-2"><Field label="Menü adresi"><Input value={base} onChange={(e) => setBase(e.target.value)} data-testid="admin-qr-base-input" /></Field></div>
          <Field label="İlk masa no"><Input type="number" min={1} value={start} onChange={(e) => setStart(e.target.value)} data-testid="admin-qr-start-input" /></Field>
          <Field label="Masa sayısı"><Input type="number" min={0} max={100} value={count} onChange={(e) => setCount(e.target.value)} data-testid="admin-qr-count-input" /></Field>
        </Panel>
        <div className="grid md:grid-cols-[auto_1fr] gap-6 mb-10 items-start">
          <QrCard url={base} label="Genel Menü" id="qr-general" size={220} />
          <Panel className="p-6">
            <h2 className="font-serif-ym text-2xl font-semibold">Genel QR</h2>
            <p className="text-sm text-[#6B5E56] mt-2">Vitrin, kapı, paket servis poşeti ve Instagram için kullanın. Masa numarası içermez.</p>
            <a href={base} target="_blank" rel="noopener noreferrer" className="mt-4 inline-flex items-center gap-2 text-sm text-[#9E7B27]" data-testid="admin-qr-open-menu-link"><ExternalLink size={14} /> Menüyü aç</a>
            <button onClick={() => download("qr-general", "yeni-mercan-menu")} className="mt-4 ml-4 inline-flex items-center gap-2 text-sm text-[#9E7B27]" data-testid="admin-qr-generator-download-btn"><Download size={14} /> Yüksek çözünürlük indir</button>
          </Panel>
        </div>
        <h2 className="font-serif-ym text-2xl font-semibold mb-4">Masa QR Kodları</h2>
      </div>
      <div ref={ref} className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 print:grid-cols-3" data-testid="admin-qr-table-grid">
        {tables.map((t) => <QrCard key={t} url={`${base}?table=${t}`} label={`Masa ${t}`} id={`qr-table-${t}`} size={150} />)}
      </div>
    </div>
  );
}
